export default __webpack_public_path__ + "static/media/tracking.48992321.svg";